import { gql, type OperationVariables } from '@apollo/client';
import { EEntityType } from '@sharedInterfaces/globalEnums';
import type ICertificate from '@sharedInterfaces/ICertificate';
import Certificate, { CertificateGQL } from '@src/Objects/Certificate';
import { setCertificates } from '@store/reducer/certificatesReducer';
import { setCompanyAllCertificates, setCompanyVersion } from '@store/reducer/companyReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const q = gql`
query($version:Int!) {
    certificates(version:$version){
        version
        certificates
        ${CertificateGQL}
    }
},
`;

interface CertificateResponse {
    certificates: { version: number; certificates: ICertificate[] };
}

export default async function getCertificates() {
    const state = store.getState();
    const versions = state.company.versions;
    const variables: OperationVariables = {
        version: versions.certificate,
    };
    return GraphQL.query<CertificateResponse>(q, variables, undefined).then((obj) => {
        if (!obj) throw new Error('Fehler beim laden der Certificates.');
        if (obj.certificates.certificates) {
            const data = obj.certificates.certificates.map((p: ICertificate) => new Certificate(p));
            store.dispatch(setCompanyVersion(EEntityType.CERTIFICATE, obj.certificates.version));
            store.dispatch(setCertificates(data));
            // Auch in allCertificates speichern für EditCertificateList
            store.dispatch(
                setCompanyAllCertificates(
                    data.map((cert) => ({
                        id: cert.id,
                        title: cert.title,
                        version: cert.version,
                        durationInDays: cert.durationInDays,
                        otherNames: cert.otherNames || [],
                    })),
                ),
            );
            return data;
        }
        return state.certificates;
    });
}
